<template lang="pug">
	.e24-header
		back-to-top(bottom="30px" right="20px")
			button(type="button" class="btn btn-info btn-to-top")
				span
					img(src="~Common/img/apple-keyboard-control.svg")
		.navbar
			router-view

			.nav-bar-container
				.top-logo
					.logo
						app-link(:to="navLinks.logo")
							img(class="logo-image" src="~Common/img/logo_250x250.png" alt="EasyTitle24.com")
					.staging-flag(v-if="isStagingEnv") Staging Environment
					.announce(v-if="displayAnnounce") {{announce}}

					.menu-hamburger(@click="isOpenHambuger = !isOpenHambuger")
						svg(
						v-if="!isOpenHambuger"
						width="1.9em"
						height="1.9em"
						viewBox="0 0 16 16"
						class="bi bi-sort-down"
						fill="green"
						xmlns="http://www.w3.org/2000/svg")
							path(fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z")

						svg(
						v-if="isOpenHambuger"
						width="1.9em"
						height="1.9em"
						viewBox="0 0 16 16"
						class="bi bi-sort-down"
						fill="green"
						xmlns="http://www.w3.org/2000/svg")
							path(fill-rule="evenodd" d="M3 13a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-1 0v10a.5.5 0 0 0 .5.5z")
							path(fill-rule="evenodd" d="M5.354 4.854a.5.5 0 0 0 0-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L3 3.207l1.646 1.647a.5.5 0 0 0 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 9a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z")

				.menu-main
					ul.menu
						li
							a(class="menu-top-nav" id="desktop_myprojects_btn" :class="{ activate: currentPath === '/project/list' }" :href="navLinks.myProjects")
								span My projects
						li
							app-link(class="menu-top-nav" id="desktop_services_btn" :class="{ activate: currentPath === '/services' }" :to="navLinks.services")
								span Services
						li
							app-link(class="menu-top-nav" id="desktop_resources_btn" :class="{ activate: currentPath === '/resources' }" :to="navLinks.resources")
								span Resources
						li
							app-link(class="menu-top-nav" id="desktop_contact_btn" :class="{ activate: currentPath === '/contact-us' }" :to="navLinks.contactUs")
								span Contact Us
						li(v-if="!currentLogin.status")
							login-button
						li(class="li-admin" v-if="currentLogin.status")
							a( class="menu-top-nav" :class="{ activate: currentPath === '/my-account' }")

								b-dropdown(id="dropdown-admin" text="My Account" class="m-md-2-ux" variant="link" right)
									a(:href="navLinks.activeProject") Edit active project

									a(:href="navLinks.myAccount" id="desktop_myaccount_btn") Account info
									admin-button(v-if="currentLogin.role.can('UPDATE', 'ORDER')")
									login-button(v-if="currentLogin.status")

				.responsive-menu(v-if="isOpenHambuger && this.isValidWidthResponsive")
					.background(:style="{ height: submenuHeight + 'px' }")
						.menu-items
							a(class="link" class-active="active" id="mobile_myprojects_btn" :class="{ 'active': currentPath === '/project/list' }" :href="navLinks.myProjects")
								span My projects

							span.servicesHeader Services
								app-link.mt-2.pt-1(class="linkServices" id="mobile_doityourself_btn" :class="{ 'mobile-link-active': currentPath === '/do-it-yourself' }" :to="navLinks.doItYourself" class-active="active")
									.frame
									span.text Do It Yourself

								app-link(class="linkServices" id="mobile_fullservices_btn" :class="{ 'mobile-link-active': currentPath === '/full-service' }" :to="navLinks.fullService" class-active="active")
									.frame
									span.text.pt-1 Full Service Consulting

							app-link(class="link" class-active="active" id="mobile_resources_btn" :to="navLinks.resources")
								span Resources
							app-link(class="link" class-active="active" id="mobile_contact_btn" :class="{ active: currentPath === '/contact-us' }" :to="navLinks.contactUs")
								span Contact Us

							span(v-if="currentLogin.status" class="servicesHeader") My account
								a.mt-2.pt-1(v-if="currentLogin.status" class="linkServices activate" :href="navLinks.activeProject")
									.frame
									span.text Edit active project

								a.pt-1(v-if="currentLogin.status" class="linkServices" id="mobile_accountinfo_btn" :class="{ 'mobile-link-active': currentPath === '/my-account' }" :href="navLinks.myAccount")
									.frame
									span.text Account Info

								admin-button(v-if="currentLogin.role && currentLogin.role.can('UPDATE', 'ORDER')")

								login-button.pt-2(v-if="currentLogin.status")

			.sub-menu(id="submenu" v-if="isResponsiveSubmenu")
				app-link(:to="navLinks.doItYourself" id="services_doityourself_btn" class="element left" class-active="active")
					span Do It Yourself

				app-link(:to="navLinks.fullService" id="services_fullservice_btn" class="element right" class-active="active")
					div
						span.text Full Service Consulting
</template>

<script>
import {Role} from 'janux-authorize'
import moment from 'moment'
export default {
	name: 'nav-bar',
	data: function () {
		return {
			navLinks: {},
			isOpenHambuger: false,
			isValidWidthResponsive: true,
			isover: false,
			buttonType: 'elastic',
			isActive: false,
			size: 'xs',
			color: 'green',
			activeColor: '#0066ff',
			isResponsiveSubmenu: false,
			submenuHeight: null,
			less400pxWidth: false,
			currentPath: '',
			currentLogin: false,
			isCallActiveProject: true,
			ready: false,
			isStagingEnv: false,
			displayAnnounce: false,
			announce: ''
		}
	},
	created () {
		this.$e24Common.security.getSharedLoginStatus().then((status) => {
			this.currentLogin = status
			if (this.currentLogin.status) {
				this.currentLogin.role = Role.fromJSON(status.role)
			}
			this.ready = true
		})
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		this.isStagingEnv = this.$e24Common.storageService.findItem('isStagingEnv', true)

		const config = this.$e24Common.storageService.findItem('config', true)
		const announceSchedule = config.announceSchedule
		this.displayAnnounce = moment().isBetween(announceSchedule.from, announceSchedule.to)
		this.announce = config.announce
	},
	mounted: function () {
		this.isShowSubmenu()
		window.addEventListener('resize', this.isShowSubmenu)
		this.readPath()
	},
	methods: {
		readPath: function () {
			let route = this.$route.path
			if (route === '/do-it-yourself' || route === '/full-service') {
				this.currentPath = '/services'
			} else if (route === '/faq' ||
				route === '/faq-a' ||
				route === '/faq-b' ||
				route === '/faq-c' ||
				route === '/faq-d' || route === '/faq-e' ||
				route === '/faq-f' ||
				route === '/faq-g' ||
				route === '/faq-h' ||
				route === '/faq-i' ||
				route === '/compliance-wizard' ||
				route === '/prices' ||
				route === '/privacy-policy' ||
				route === '/resource-links' ||
				route === '/terms-and-conditions' ||
				route === '/cost-estimator') {
				this.currentPath = '/resources'
			} else if (route === '/' || route === '/project/list' || route[1] === 'p') {
				this.currentPath = '/project/list'
			} else if (route === '/my-account') {
				this.currentPath = '/my-account'
			} else {
				this.currentPath = route
			}
		},
		isShowSubmenu: function () {
			let rutaSubmenu = this.$route.path
			let widthPage = document.documentElement.clientWidth
			let heightPage = document.documentElement.clientHeight
			this.submenuHeight = heightPage

			if (widthPage >= 993) {
				if (rutaSubmenu === '/do-it-yourself' ||
					rutaSubmenu === '/full-service' ||
					rutaSubmenu === '/services/' ||
					rutaSubmenu === '/services') {
					this.isResponsiveSubmenu = true
				} else {
					this.isResponsiveSubmenu = false
				}
				this.isValidWidthResponsive = false
			} else if (widthPage < 993) {
				this.isValidWidthResponsive = true
				if (
					rutaSubmenu === '/do-it-yourself' ||
					rutaSubmenu === '/full-service' ||
					rutaSubmenu === '/services/' ||
					rutaSubmenu === '/services') {
					this.isResponsiveSubmenu = true
				} else {
					this.isResponsiveSubmenu = false
				}
			}

			if (widthPage < 400) {
				this.less400pxWidth = true
			} else {
				this.less400pxWidth = false
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/components/nav-bar.vue